import PropTypes from 'prop-types';

const getByViewport = propType => ({
  xs: propType,
  sm: propType,
  md: propType,
  lg: propType,
  xl: propType
});
/**
 * Utilities for props that allow different values to be applied at different viewports.
 *
 * These should apply viewport inheritance such that if a viewport is undefined, the value is
 * taken from the next smallest viewport for which a value is available. For example, a
 * responsive prop { xs: 2, lg: 3 } should apply 2 at sizes sm and md, and 3 at size xl.
 *
 * @property {Function} getByViewport - returns an object where each each viewport has a key
 *   containing the provided argument.
 * @property {Function} getTypeByViewport - returns a PropTypes shape validator for an object where
 *   each viewport has a key containing the provided proptype.
 * @property {Function} getTypeOptionallyByViewport - returns a PropTypes validator that accepts
 *   either the provided proptype on its own, or the output of getTypeByViewport
 */


export default {
  getByViewport,
  getTypeByViewport: propType => PropTypes.shape(getByViewport(propType)),
  getTypeOptionallyByViewport: propType => PropTypes.oneOfType([propType, PropTypes.shape(getByViewport(propType))])
};